import { Component, Vue } from 'vue-property-decorator'

@Component
export default class Testable extends Vue {
	public getTestId(fieldRef: string): string {
		return [this.$attrs['data-testid'], fieldRef].filter(Boolean).join('-')
	}
}
